/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_APPLICATION_QUERY_JLP = gql`
  query candidateApplicationQueryJLPNoId {
    candidate {
      applications(limit: 1) {
        collection {
          id
          bearerToken
          folder {
            name
          }
          responses(syncPrompts: true) {
            id
            value
            url
            docs
            prompt {
              id
              title
              typeName
              categoryName
              metadata
              documentInstruction
              documentSampleUrl
              documentTag {
                name
                parameters {
                  processable
                  landingPageProcessable
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const CANDIDATE_APPLICATION_COMPLETION_QUERY_JLP = gql`
  query candidateApplicationCompletionQueryJLPNoId {
    candidate {
      applications(limit: 1) {
        collection {
          id
          callToActionCompletionMessage
        }
      }
    }
  }
`;

// NOTE: Not used
export const CANDIDATE_APPLICATION_QUERY = gql`
  query candidateApplicationQuery {
    candidate {
      applications(limit: 1) {
        collection {
          id
          email
          msisdn
          createdAt
          updatedAt
          deletedAt
          firstName
          lastName
          gender
          education
          schoolName
          graduationYear
          lastEmployer
          yearsOfExp
          bearerToken
          address {
            street
            state
            city
            country
            postalCode
            latitude
            longitude
          }
          prompts {
            id
            title
            categoryName
            metadata
            documentInstruction
            documentSampleUrl
          }
          responses {
            id
            value
            url
            prompt {
              id
              title
              categoryName
              metadata
              documentInstruction
              documentSampleUrl
            }
          }
        }
      }
    }
  }
`;
